import { useContext } from "react";

import { APIErrorTypes } from "../types/apiError";

import AuthTransactionContext from "../contexts/AuthTransactionContext";

import getApiClient from "lib/apiClient/getApiClient";

// Returns a version of the API client that checks for an expired auth transaction and updates the state accordingly before proceeding with the rest of the response logic
const useAuthTransactionApiClient = () => {
  const { setIsTransactionExpired } = useContext(AuthTransactionContext);

  const clientWithExpiredTransactionCheck: typeof fetch = (path, data) => {
    return getApiClient()(path, {
      ...data,
    }).then(async (response) => {
      if (!response.ok) {
        try {
          const errorData = await response.clone().json();

          if (errorData.type === APIErrorTypes.AuthTransactionExpired) {
            setIsTransactionExpired(true);
          }
        } catch {
          // Response body is not JSON — not an expired transaction error
          console.warn("Non-JSON error response from auth transaction API", {
            status: response.status,
          });
        }
      }

      return response;
    });
  };

  return clientWithExpiredTransactionCheck;
};

export default useAuthTransactionApiClient;
